/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from "react";
import { Editor } from "@tinymce/tinymce-react";

interface Props {
  initialValue: string;
  onFocus?: () => void;
  onEditorChange?: (content: string) => void;
  resetOnFocus?: boolean;
}

const EditorText: React.FC<Props> = ({ initialValue, onFocus, onEditorChange, resetOnFocus }) => {
  const [editorValue, setEditorValue] = useState(initialValue);

  useEffect(() => {
    setEditorValue(initialValue);
  }, [initialValue]);

  const handleEditorFocus = () => {
    if (resetOnFocus) {
      setEditorValue(initialValue);
    }
    if (onFocus) {
      onFocus();
    }
  };

  const handleEditorChange = (content: string) => {
    setEditorValue(content);
    if (onEditorChange) {
      onEditorChange(content);
    }
  };

  return (
    <Editor
      apiKey='fpuko1awf7rkdvi6s6zhm335aev775s20g20yip11n9724so'
      value={editorValue}
      onEditorChange={handleEditorChange}
      onFocus={handleEditorFocus}
      init={{
        plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
        menubar : 'file edit insert format table tc',
        toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
        tinycomments_mode: 'embedded',
        tinycomments_author: 'Author name',
        branding: false,
        mergetags_list: [
          { value: 'First.Name', title: 'First Name' },
          { value: 'Email', title: 'Email' },
        ],
        ai_request: (request: any, respondWith: { string: (arg0: () => Promise<never>) => any; }) => respondWith.string(() => Promise.reject("See docs to implement AI Assistant")),
        language: 'fr_FR',
      }}
    />
  );
};

export default EditorText;
